import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
import USE_MERCURE from '~/const/mercure';
import { CATEGORY_INFIX, EDITO_INFIX, PRODUCT_INFIX, STATIC_INFIX, SEARCH_INFIX } from '~/const/infix';

var buildHomeUrl = function buildHomeUrl(locale) {
  return "/".concat(locale.market, "/").concat(locale.language);
};

var CgvType = {
  PRO: 'cgv-pro',
  MARKETPLACE: 'cgv-marketplace',
  DEFAULT: 'cgv'
};

var buildCategoryUrl = function buildCategoryUrl(locale, slug, hash) {
  return "/".concat(locale.market, "/").concat(locale.language, "/").concat(CATEGORY_INFIX, "/").concat(slug, "-").concat(hash);
};

var buildProductUrl = function buildProductUrl(locale, slug, reference, offer) {
  var url = "/".concat(locale.market, "/").concat(locale.language, "/").concat(PRODUCT_INFIX, "/").concat(slug, "-").concat(reference, ".htm");

  if (offer) {
    url = "".concat(url, "?offer=").concat(offer);
  }

  return url;
};

var buildCustomProductUrl = function buildCustomProductUrl(locale, reference) {
  return "/".concat(locale.market, "/").concat(locale.language, "/configurator/product/").concat(reference);
};

var buildStaticUrl = function buildStaticUrl(locale, slug, oldVersion) {
  if (oldVersion) {
    // handle WEB static pages url until they switch to nuxt
    return "/".concat(locale.market, "/").concat(locale.language, "/").concat(slug);
  }

  return "/".concat(locale.market, "/").concat(locale.language, "/").concat(STATIC_INFIX, "/").concat(slug);
};

var buildSearchUrl = function buildSearchUrl(locale, query) {
  return "/".concat(locale.market, "/").concat(locale.language, "/").concat(SEARCH_INFIX, "/").concat(query);
};

var buildEditoUrl = function buildEditoUrl(locale, page) {
  return "/".concat(locale.market, "/").concat(locale.language, "/").concat(EDITO_INFIX, "/").concat(page);
};

var buildMyAccountUrl = function buildMyAccountUrl(locale) {
  return "/".concat(locale.market, "/").concat(locale.language, "/user");
};

var buildFaqUrl = function buildFaqUrl(locale, page) {
  return "/".concat(locale.market, "/").concat(locale.language, "/help/faq/").concat(page);
};

var buildContactFormUrl = function buildContactFormUrl(locale, page) {
  return "/".concat(locale.market, "/").concat(locale.language, "/help/contact/").concat(page);
};

var buildReturnFormUrl = function buildReturnFormUrl(locale, page) {
  return "/".concat(locale.market, "/").concat(locale.language, "/help/return/").concat(page);
};

var buildCgvUrl = function buildCgvUrl(locale, page) {
  return "/".concat(locale.market, "/").concat(locale.language, "/").concat(EDITO_INFIX, "/legal/").concat(CgvType[page] || CgvType.DEFAULT);
};

var buildShippingUrl = function buildShippingUrl(locale) {
  return "/".concat(locale.market, "/").concat(locale.language, "/t/shipping");
};

var buildPaymentUrl = function buildPaymentUrl(locale) {
  return "/".concat(locale.market, "/").concat(locale.language, "/t/payment");
};

var buildPaymentPaypalPendingUrl = function buildPaymentPaypalPendingUrl(locale) {
  return "/".concat(locale.market, "/").concat(locale.language, "/t/payment-paypal-pending");
};

var buildPaymentPaypalCanceledUrl = function buildPaymentPaypalCanceledUrl(locale) {
  return "/".concat(locale.market, "/").concat(locale.language, "/t/payment-paypal-canceled");
};

var buildPaymentConfirmedUrl = function buildPaymentConfirmedUrl(locale) {
  return "/".concat(locale.market, "/").concat(locale.language, "/t/confirmed");
};

var buildPaymentRefusedUrl = function buildPaymentRefusedUrl(locale) {
  return "/".concat(locale.market, "/").concat(locale.language, "/t/refused");
};

var buildMerchantUrl = function buildMerchantUrl(locale, slug, reference) {
  return "/".concat(locale.market, "/").concat(locale.language, "/m/").concat(slug, "-").concat(reference);
};

var buildCartUrl = function buildCartUrl(locale) {
  return USE_MERCURE(locale.iso) ? "/".concat(locale.market, "/").concat(locale.language, "/cart") : "/".concat(locale.market, "/").concat(locale.language, "/panier.html");
};

var buildLoginUrl = function buildLoginUrl(locale, isTunnel) {
  return isTunnel ? "/".concat(locale.market, "/").concat(locale.language, "/t/login") : "/".concat(locale.market, "/").concat(locale.language, "/login");
};

var buildSignupUrl = function buildSignupUrl(locale, isTunnel) {
  return isTunnel ? "/".concat(locale.market, "/").concat(locale.language, "/t/signup") : "/".concat(locale.market, "/").concat(locale.language, "/signup");
};

export var urlBuilder = {
  buildCartUrl: buildCartUrl,
  buildCgvUrl: buildCgvUrl,
  buildShippingUrl: buildShippingUrl,
  buildHomeUrl: buildHomeUrl,
  buildLoginUrl: buildLoginUrl,
  buildMerchantUrl: buildMerchantUrl,
  buildMyAccountUrl: buildMyAccountUrl,
  buildPaymentUrl: buildPaymentUrl,
  buildPaymentPaypalPendingUrl: buildPaymentPaypalPendingUrl,
  buildPaymentPaypalCanceledUrl: buildPaymentPaypalCanceledUrl,
  buildPaymentConfirmedUrl: buildPaymentConfirmedUrl,
  buildPaymentRefusedUrl: buildPaymentRefusedUrl,
  buildProductUrl: buildProductUrl,
  buildCustomProductUrl: buildCustomProductUrl,
  buildSignupUrl: buildSignupUrl
};
export default {
  methods: {
    buildCartUrl: buildCartUrl,
    buildCategoryUrl: buildCategoryUrl,
    buildContactFormUrl: buildContactFormUrl,
    buildEditoUrl: buildEditoUrl,
    buildFaqUrl: buildFaqUrl,
    buildLoginUrl: buildLoginUrl,
    buildProductUrl: buildProductUrl,
    buildReturnFormUrl: buildReturnFormUrl,
    buildSearchUrl: buildSearchUrl,
    buildStaticUrl: buildStaticUrl
  }
};